import moment from 'moment';

import { Site } from '../account/site.model';
import { FocusRange } from '../focus-range.model';
import { Invoice } from '../invoice/invoice.model';
import { NotificationEventType } from '../types/notification-event-type';

import { Icon, WattsonNotification } from './wattson-notification.model';

/**
 * Model for API Invoice Notification Model
 */
export class InvoiceNotification extends WattsonNotification {
  /**
   * The target of the notification is an Invoice.
   */
  declare target: Invoice;

  constructor(attributes: Partial<InvoiceNotification> = {}) {
    super();
    Object.assign(this, attributes);
  }

  getIcons(): Icon[] {
    return [{ icon: 'invoice-published', tooltip: 'notification_panel.invoice.validated' }];
  }

  getTypeIcon(): string {
    switch (this.eventType) {
      case NotificationEventType.newPublishedInvoice:
        return 'assignment_turned_in';
      case NotificationEventType.newValidatedInvoice:
        return 'assignment_turned_in';
      default:
        return 'face';
    }
  }

  getNotificationAuthor(): string {
    if (!this.target) return undefined;
    return this.target.generatedBy ? this.target.generatedBy.email : undefined;
  }

  getFocus(): FocusRange[] {
    return [
      new FocusRange({
        site: new Site({
          id: this.target.deliveryPoint.siteId,
          labels: {
            internal: this.target.deliveryPoint.siteLabels.internal,
            external: this.target.deliveryPoint.siteLabels.external || this.target.deliveryPoint.siteLabels.internal,
          },
        }),
      }),
    ];
  }

  getLink(): string {
    return '/invoice/standard';
  }

  getNotificationMessageParams() {
    return {
      date: moment(this.target.month).format('MMMM YYYY'),
      site: this.target.deliveryPoint.siteLabels.external || this.target.deliveryPoint.siteLabels.internal,
    };
  }
}
